import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import BeneficiaryReimbursementList from '../../components/BeneficiaryReimbursement/BeneficiaryReimbursementList';
import { useNavigate, useParams } from 'react-router-dom';
import SubHeader from '../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import CreateButton from '../../components/Tools/CreateButton';
import MainFilter from '../../components/Tools/MainFilter';
import DashboardFilter from '../Dashboard/components/DashboardFilter';
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#1890ff",
        ...theme.applyStyles("dark", {
          backgroundColor: "#177ddc",
        }),
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
    ...theme.applyStyles("dark", {
      backgroundColor: "rgba(255,255,255,.35)",
    }),
  },
}));

export default function BeneficiaryReimbursementListPage() {
    const navigate = useNavigate();
    const { authData, financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [fyId, setFyId] = useState(fyIdRef.current);
    const { listType } = useParams();
    const [title, setTitle] = useState('');
    const [all, setAll] = useState(false);

    const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
    });

    const [filterApplied, setFilterApplied] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
    });

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleInput = async (e) => {
        const { name, value } = e.target;
        setFilterPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const bootList = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    };

    const handleFilterRemove = async (name) => {
        const newPayload = {
            ...filterPayload,
            [name]: "",
        };
        setFilterPayload(newPayload);
        setFilterApplied(newPayload);
    };

    const getDefaultDateRange = (fyIdValue) => {
        const selectedFy = fyList?.find((fy) => String(fy?.id) === String(fyIdValue));
        if (!selectedFy?.start_year || !selectedFy?.end_year) {
            return { from_date: "", to_date: "" };
        }
        return {
            from_date: `${selectedFy.start_year}-04-01`,
            to_date: `${selectedFy.end_year}-03-31`,
        };
    };

    const { from_date, to_date } = getDefaultDateRange(fyId);

    const handleToggleChange = () => {
        setAll((prev) => !prev);
    };

    const defaultSelection = () => {
        if (listType === 'approval') {
            setTitle("DBT/Nach Approval");
        } else if (listType === 'payment') {
            setTitle("DBT/Nach Payment");
        } else {
            setTitle("DBT/Nach");
        }
    };

    useEffect(() => {
        defaultSelection();
    }, [listType]);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
        setFyId(fyIdRef.current);
    };

    return (
        <div>
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />
            <div className='scheme p-2'>
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin: 0 }}>{title}</h4>
                        <CustomBreadcrumbs linksArray={[]} title={title} />
                    </div>
                    <div className="col-md-6">
                        {title === "DBT/Nach Approval" && (
                            <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                                <button type="button" className="navigation_button" onClick={() => navigate("/beneficiary-reimbursement/payment")}>
                                    <span className="fs-14px">DBT/Nach Payment</span>
                                </button>
                                {authData.user.user_type === 'l1' && (
                                    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                                        <p>All</p>
                                        <AntSwitch defaultChecked inputProps={{ "aria-label": "ant design" }} onChange={handleToggleChange} />
                                        <p>Pending</p>
                                    </Stack>
                                )}
                            </div>
                        )}
                        {title === "DBT/Nach Payment" && (
                            <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                                <button type="button" className="navigation_button" onClick={() => navigate("/beneficiary-reimbursement/approval")}>
                                    <span className="fs-14px">DBT/Nach Approval</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <DashboardFilter
                    openFilterModal={setOpen}
                    filterPayload={filterApplied}
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
                <BeneficiaryReimbursementList
                    departmentId={filterApplied.department_id}
                    fromDate={from_date}
                    toDate={to_date}
                    is_all={all}
                />
                {!listType && authData.user.user_type === 'l1' && (
                    <CreateButton title={"Add DBT/Nach"} url={"/add-beneficiary-reimbursement"} />
                )}
                <MainFilter
                    open={open}
                    handleClose={handleClose}
                    handleInput={handleInput}
                    handleOpen={handleOpen}
                    handleFilterClick={bootList}
                    filterPayload={filterPayload}
                    setConsolidate={setFilterPayload}
                    type="DBT/Nach"
                />
            </div>
        </div>
    );
}
